module.exports = __webpack_public_path__ + "img/address-book-icon-nobg.7b0b0e16.svg";